import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css"
import "./common.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// all page import and create react router
import Home from "./Pages/Home/Home";
import Layout from "./Layout/Layout";
import AboutMe from "./Pages/About/AboutMe";
import Services from "./Pages/Services/Services";
import PortfolioData from "./Pages/Portfolio/PortfolioData";
import SinglePortfolio from "./Pages/Portfolio/SinglePortfolio";
import Contact from "./Pages/Contact/Contact";
import Error from "./Pages/Error/Error";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout></Layout>,
    children: [
      {
        path: "/",
        element: <Home></Home>,
        loader: ({ params }) => fetch("portfolio.json"),
      },
      {
        path: "about",
        element: <AboutMe />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "portfolio",
        element: <PortfolioData />,
        loader: ({ params }) => fetch("portfolio.json"),
      },
      {
        path: "portfolio/:singleportfolio",
        element: <SinglePortfolio />,
        loader: ({ params }) => fetch("portfolio.json"),
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <Error />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
